import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Card,
    CardContent,
    IconButton
} from "@mui/material";

import {
    AddCircleOutline,
    RemoveCircleOutline
} from "@mui/icons-material";

import {
    collection,
    getDocs,
    addDoc,
    Timestamp
} from "firebase/firestore";

import { db } from "../../firebase";
import Swal from "sweetalert2";

function Addpurchase() {

    const [dealers, setDealers] = useState([]);
    const [products, setProducts] = useState([]);
    const [payModes, setPayModes] = useState([]);

    const [items, setItems] = useState([]);

    const [form, setForm] = useState({
        purchaseno: "",
        purchasedate: new Date().toISOString().split("T")[0],
        dealerId: "",
        subtotal: 0,
        discount: 0,
        grandtotal: 0,
        paid: 0,
        paymentmode: "",
        remaining: 0
    });

    useEffect(() => {
        loadDealers();
        loadProducts();
        loadPayModes();

        setItems([
            {
                productId: "",
                qty: "",
                rate: "",
                total: 0,
                discount: "",
                finaltotal: 0
            }
        ]);
    }, []);

    const loadDealers = async () => {
        const snap = await getDocs(collection(db, "dealers"));
        setDealers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };

    const loadProducts = async () => {
        const snap = await getDocs(collection(db, "purchase_products"));
        setProducts(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };

    const loadPayModes = async () => {
        const snap = await getDocs(collection(db, "payment_modes"));
        setPayModes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };

    const addItem = () => {
        setItems((prev) => [
            ...prev,
            {
                productId: "",
                qty: "",
                rate: "",
                total: 0,
                discount: "",
                finaltotal: 0
            }
        ]);
    };

    const removeItem = (index) => {
        if (items.length === 1) return;

        const updated = [...items];
        updated.splice(index, 1);
        setItems(updated);
        calculateTotals(updated);
    };

    const handleItemChange = (index, field, value) => {

        const updated = [...items];
        updated[index][field] = value;

        const qty = Number(updated[index].qty || 0);
        const rate = Number(updated[index].rate || 0);
        const discount = Number(updated[index].discount || 0);

        const total = qty * rate;
        const finaltotal = total - discount;

        updated[index].total = total;
        updated[index].finaltotal = finaltotal;

        setItems(updated);
        calculateTotals(updated);
    };

    const calculateTotals = (data) => {

        const subtotal = data.reduce((sum, i) => sum + Number(i.total || 0), 0);
        const discount = data.reduce((sum, i) => sum + Number(i.discount || 0), 0);
        const grandtotal = subtotal - discount;
        const remaining = grandtotal - Number(form.paid || 0);

        setForm(prev => ({
            ...prev,
            subtotal,
            discount,
            grandtotal,
            remaining
        }));

    };

    const handleChange = (e) => {

        const updated = {
            ...form,
            [e.target.name]: e.target.value
        };

        if (e.target.name === "paid") {
            updated.remaining = updated.grandtotal - Number(e.target.value || 0);
        }

        setForm(updated);
    };

    const handleSave = async () => {

        if (!form.dealerId) {
            Swal.fire("Error", "Select Dealer", "error");
            return;
        }

        if (items.length === 0) {
            Swal.fire("Error", "Add at least one product", "error");
            return;
        }

        for (let item of items) {
            if (!item.productId || item.qty <= 0 || item.rate <= 0) {
                Swal.fire("Error", "Product, Qty and Rate required", "error");
                return;
            }
        }

        try {

            const purchaseRef = await addDoc(collection(db, "purchases"), {
                ...form,
                items,
                purchasedate: form.purchasedate,
                createdAt: Timestamp.now()
            });

            if (form.paid > 0) {

                await addDoc(collection(db, "dealerPayments"), {
                    dealerId: form.dealerId,
                    purchaseId: purchaseRef.id,
                    amount: form.paid,
                    paymentMode: form.paymentmode,
                    date: Timestamp.now()
                });

            }

            Swal.fire("Success", "Purchase Saved", "success");

            setItems([]);
            addItem();
            setForm({
                purchaseno: "",
                purchasedate: new Date().toISOString().split("T")[0],
                dealerId: "",
                subtotal: 0,
                discount: 0,
                grandtotal: 0,
                paid: 0,
                paymentmode: "",
                remaining: 0
            });

        } catch (err) {
            Swal.fire("Error", err.message, "error");
        }

    };

    return (

        <Box p={1}>

            <Typography variant="h5" fontWeight="bold" mb={2}>
                Add Purchase
            </Typography>

            <Card>
                <CardContent>

                    <div className="row">

                        <div className="col-sm-4">
                            <TextField
                                label="Purchase No"
                                name="purchaseno"
                                value={form.purchaseno}
                                onChange={handleChange}
                                size="small"
                                fullWidth
                            />
                        </div>

                        <div className="col-sm-4">
                            <TextField
                                type="date"
                                name="purchasedate"
                                value={form.purchasedate}
                                onChange={handleChange}
                                size="small"
                                fullWidth
                            />
                        </div>

                        <div className="col-sm-4">
                            <TextField
                                select
                                label="Dealer"
                                name="dealerId"
                                value={form.dealerId}
                                onChange={handleChange}
                                size="small"
                                fullWidth
                            >
                                {dealers.map(d => (
                                    <MenuItem key={d.id} value={d.id}>
                                        {d.dealerName}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>

                    </div>

                </CardContent>
            </Card>

            <Card sx={{ mt: 2 }}>
                <CardContent>

                    <Table
                        size="small"
                        sx={{
                            border: "1px solid #ddd",
                            "& th": {
                                background: "#f5f5f5",
                                fontWeight: "bold",
                                border: "1px solid #ddd"
                            },
                            "& td": {
                                border: "1px solid #ddd"
                            }
                        }}
                    >

                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell width="35%">Product</TableCell>
                                <TableCell>Qty</TableCell>
                                <TableCell>Rate</TableCell>
                                <TableCell>Total</TableCell>
                                <TableCell>Discount</TableCell>
                                <TableCell>Final</TableCell>
                                <TableCell align="center">Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>

                            {items.map((item, index) => (
                                <TableRow key={index} hover>

                                    <TableCell>{index + 1}</TableCell>

                                    <TableCell>
                                        <TextField
                                            select
                                            size="small"
                                            fullWidth
                                            value={item.productId}
                                            onChange={(e) => handleItemChange(index, "productId", e.target.value)}
                                        >
                                            {products.map(p => (
                                                <MenuItem key={p.id} value={p.id}>
                                                    {p.productName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </TableCell>

                                    <TableCell>
                                        <TextField
                                            type="number"
                                            size="small"
                                            value={item.qty}
                                            onChange={(e) => handleItemChange(index, "qty", e.target.value)}
                                            sx={{ width: 80 }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <TextField
                                            type="number"
                                            size="small"
                                            value={item.rate}
                                            onChange={(e) => handleItemChange(index, "rate", e.target.value)}
                                            sx={{ width: 100 }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Typography fontWeight="bold">
                                            {item.total}
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        <TextField
                                            type="number"
                                            size="small"
                                            value={item.discount}
                                            onChange={(e) => handleItemChange(index, "discount", e.target.value)}
                                            sx={{ width: 90 }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Typography color="green" fontWeight="bold">
                                            {item.finaltotal}
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center">

                                        <IconButton
                                            color="primary"
                                            onClick={addItem}
                                            size="small"
                                        >
                                            <AddCircleOutline />
                                        </IconButton>

                                        <IconButton
                                            color="error"
                                            onClick={() => removeItem(index)}
                                            disabled={items.length === 1}
                                            size="small"
                                        >
                                            <RemoveCircleOutline />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>
                            ))}

                        </TableBody>

                    </Table>

                </CardContent>
            </Card>

            <Card sx={{ mt: 2 }}>
                <CardContent>

                    <div className="row">

                        <div className="col-sm-2">
                            <TextField label="Subtotal" value={form.subtotal} size="small" fullWidth />
                        </div>

                        <div className="col-sm-2">
                            <TextField label="Discount" value={form.discount} size="small" fullWidth />
                        </div>

                        <div className="col-sm-2">
                            <TextField label="Grand Total" value={form.grandtotal} size="small" fullWidth />
                        </div>

                        <div className="col-sm-2">
                            <TextField
                                label="Paid"
                                name="paid"
                                value={form.paid}
                                onChange={handleChange}
                                size="small"
                                fullWidth
                            />
                        </div>

                        <div className="col-sm-2">
                            <TextField
                                select
                                label="Payment Mode"
                                name="paymentmode"
                                value={form.paymentmode}
                                onChange={handleChange}
                                size="small"
                                fullWidth
                            >
                                {payModes.map(p => (
                                    <MenuItem key={p.id} value={p.id}>
                                        {p.payMode}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>

                        <div className="col-sm-2">
                            <TextField label="Remaining" value={form.remaining} size="small" fullWidth />
                        </div>

                    </div>

                    <Button
                        variant="contained"
                        sx={{ mt: 3 }}
                        onClick={handleSave}
                    >
                        Save Purchase
                    </Button>

                </CardContent>
            </Card>

        </Box>
    );
}

export default Addpurchase;